import { WorkflowJobStatus } from './enums';

/**
 * Set of statuses that indicate a workflow job has finished processing
 */
export const FINISHED_WORKFLOW_JOB_STATUSES = new Set<WorkflowJobStatus>([
  WorkflowJobStatus.Skipped,
  WorkflowJobStatus.Success,
]);

/**
 * Set of statuses that indicate a workflow job is in a state to be retried
 */
export const RETRY_WORKFLOW_JOB_STATUSES = new Set<WorkflowJobStatus>([
  WorkflowJobStatus.AwaitingInteraction,
  WorkflowJobStatus.Error,
]);
